import { ApiKeyOverview } from "./apiKeyOverview";
import { NeedHelp } from "./needHelp";
export var ApiKeyDetail = function ApiKeyDetail() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ApiKeyOverview, null), /*#__PURE__*/React.createElement(NeedHelp, null));
};